import { render, staticRenderFns } from "./CloudAccountSetupList.vue?vue&type=template&id=fff8268a&scoped=true"
import script from "./CloudAccountSetupList.vue?vue&type=script&lang=js"
export * from "./CloudAccountSetupList.vue?vue&type=script&lang=js"
import style0 from "./CloudAccountSetupList.vue?vue&type=style&index=0&id=fff8268a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fff8268a",
  null
  
)

export default component.exports